<template>
  <div class="h-screen w-screen flex overflow-hidden">
    <div class="flex h-screen w-screen">
      <div
        v-if="!FullScreenMap"
        class="h-screen w-full flex ease-out duration-200"
        :class="AppClass"
      >
        <div class="w-full h-full py-5 pr-5 pl-5 overflow-auto relative flex-flex-col">
          <div class="w-full flex justify-between items-center mb-5">
            <router-link :to="{ name: 'Home' }">
              <SVG name="logo" css="w-[35px] fill-current"></SVG>
            </router-link>
          </div>
          <router-view :key="$route.path" v-if="!$root.pageLoad"></router-view>
        </div>
      </div>

      <div v-show="!FullScreenPage" class="w-full h-full relative sous-carte">
        <div
          class="absolute left-0 h-screen w-[16px] min-w-[16px] flex z-10"
          v-if="!FullScreenMap"
        >
          <div
            class="my-auto max-h-[80px] bg-flyingeye h-full flex p-[4px] cursor-pointer"
            style="border-radius: 0 4px 4px 0"
            @click="main_active = !main_active"
          >
            <SVG
              name="doubleChevron"
              :css="'m-auto w-[10px] fill-current ' + (!main_active ? 'rotate-180' : '')"
            ></SVG>
          </div>
        </div>
        <div id="mainMap" class="w-full h-full relative"></div>
        <router-view
          :key="$route.path"
          v-if="FullScreenMap && !isPopup && !$root.pageLoad"
        ></router-view>
      </div>
    </div>
  </div>

  <Device_Windows_Full v-if="$root.mainMapReady" />
</template>

<script>
import { ref } from "vue";
import { CesiumPosition } from "@/utils/constant/settings_constantes";

import SVG from "@/partials/SVG.vue";
// import MapVue from "@/partials/Map/Map.vue";
import Device_Windows_Full from "@/partials/Device/Device_Windows_Full.vue";

export default {
  name: "MILESTONE",
  components: {
    SVG,
    // MapVue,
    Device_Windows_Full
  },

  setup() {
    return {
      main_active: ref(true),
    };
  },

  mounted() {
    $root.positionMap = CesiumPosition.Main;
    $root.pageLoad = false;
    $root.mainMapReady = true;
  },
  computed: {
    goBack() {
      return () => {
        this.$router.back();
      };
    },

    FullScreenMap() {
      return this.$route?.meta?.fullscreenMap == true;
    },

    FullScreenPage() {
      let page = this.$route?.meta?.fullscreen == true;
      let admin = this.$route.fullPath.includes("admin");

      return page || admin;
    },

    AppClass() {
      if (this.FullScreenPage) {
        return "w-full";
      }

      if (!this.main_active) {
        return "min-w-[0px] max-w-[0px] opacity-0";
      }

      if (this.$root.appClassSurcharge != "") {
        return this.$root.appClassSurcharge;
      }

      return ENV.BASE_AppClass;
    },
  },
};
</script>
